import { Link } from "react-router-dom";


export default function homeClientes() {
    return (
        <div>
            <div>
                <Link to="listado">
                    Lista de Clientes
                </Link>
            </div>
            <div>
                <Link to="create">
                    Creación de Clientes
                </Link>
            </div>
        </div>
    )
}